import { useCallback, useEffect, useState } from 'react';
import { getStoredTheme, persistTheme, type Theme } from '@/lib/theme';

export function useTheme() {
    const [theme, setThemeState] = useState<Theme>(() => getStoredTheme());

    useEffect(() => {
        persistTheme(theme);
    }, [theme]);

    const toggleTheme = useCallback(() => {
        setThemeState((t) => (t === 'dark' ? 'light' : 'dark'));
    }, []);

    return { theme, toggleTheme, isDark: theme === 'dark' };
}
